import React from 'react';
import { useUserPermissions } from '../hooks/useUserPermissions';
import { AccessDenied } from './AccessDenied';
import { LoadingPage } from './LoadingSpinner';

interface PermissionGuardProps {
    children: React.ReactNode;
    permissions?: string[];
    requireAll?: boolean;
    fallback?: React.ReactNode;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
    children,
    permissions = ['manage:users'],
    requireAll = true,
    fallback,
}) => {
    const {
        hasAnyPermission,
        hasAllPermissions,
        isLoading,
        permissions: userPermissions,
    } = useUserPermissions();

    console.log('PermissionGuard check:', {
        isLoading,
        requiredPermissions: permissions,
        userPermissions,
        requireAll,
        hasAllPermissions: hasAllPermissions(permissions),
        hasAnyPermission: hasAnyPermission(permissions),
    });

    if (isLoading) {
        return <LoadingPage />;
    }

    const hasRequiredPermissions = requireAll
        ? hasAllPermissions(permissions)
        : hasAnyPermission(permissions);

    if (!hasRequiredPermissions) {
        return (
            fallback || (
                <AccessDenied
                    message={`You need additional permissions to access the management portal.`}
                />
            )
        );
    }

    return <>{children}</>;
};
